import styled from 'styled-components'

export const CloseIconWrapper = styled.div`
   user-select: none;
   position: absolute;
   width: 18px;
   height: 18px;
   right: 10px;
   background-color: white;
   display: flex;
   align-items: center;
   justify-content: center;
   cursor: pointer;
   border-radius: 5px;
`
